import React from "react";
import classNames from "classnames";
import CodeMirror from "@uiw/react-codemirror";
import { makeStyles } from 'tss-react/mui';
import {Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {java} from "@codemirror/lang-java";
import {EditorView} from "@codemirror/view";

const useStyles = makeStyles()({
    content: {
        width: "100%"
    },
    codeMirror: {
        fontSize: "16px",
    }
});

const codeEditorExtensions = [
    java(),
    EditorView.lineWrapping,
    EditorView.theme({
            // disable outline when editor is focused
            "&.cm-editor.cm-focused": {outline: "none"},

            // set min and max height
            "&": {height: "500px"},
            ".cm-content": {height: "500px"},
            ".cm-gutter": {height: "500px"},
            ".cm-scroller": {overflow: "auto"},

            // disable highlighting line
            ".cm-activeLine": {background: "transparent"},
            ".cm-activeLineGutter": {background: "transparent"}
        }
    )
];

interface EditorProps {
    value?: string;
    onValueChange: (code: string) => void;
}

const Editor = (props: EditorProps) => {
    const { value, onValueChange } = props;
    const { classes } = useStyles();
    const numberOfCharacters = value ? value.length : 0;
    const { t } = useTranslation();

    function handleValueChange(assignmentCode: string) {
        onValueChange(assignmentCode);
    }

    return(
        <main className={classes.content}>
            <CodeMirror
                className={classNames(classes.codeMirror)}
                value={value}
                extensions={codeEditorExtensions}
                onChange={handleValueChange}
            />

            <Typography variant="caption">
                {t("codeAssignmentPage:numberOfCharactersInTask", {numberOfCharacters})}
            </Typography>
        </main>
    );
}

export default Editor;